// Static content for GT Engineering Tuning Files Service landing page

export const services = [
  {
    id: 1,
    title: "Stage 1, 2 & 3",
    description: "Augmentez la puissance de votre véhicule jusqu'à +50% avec nos reprogrammations certifiées sur banc de puissance.",
    price: "À partir de 95€ HT",
    icon: "zap"
  },
  {
    id: 2,
    title: "Conversion E85",
    description: "Passez au bioéthanol E85 et économisez jusqu'à 50% sur votre carburant tout en conservant les performances d'origine.",
    price: "À partir de 115€ HT",
    icon: "fuel"
  },
  {
    id: 3,
    title: "Solution FAP / EGR / Adblue",
    description: "Optimisez votre moteur avec nos solutions pour les systèmes antipollution défaillants. Suppression DTC incluse.",
    price: "À partir de 60€ HT",
    icon: "settings"
  },
  {
    id: 4,
    title: "Options Performance",
    description: "Pop & Bang, Launch Control, Vmax OFF, Hard Cut Limiter, Crackle Map et bien plus pour personnaliser votre conduite.",
    price: "À partir de 50€ HT",
    icon: "gauge"
  }
];

export const stats = [
  { value: "15 ans", label: "d'expérience" },
  { value: "50K+", label: "Fichiers traités" },
  { value: "<20 min", label: "Temps moyen" }
];

export const howItWorks = [
  {
    step: 1,
    title: "Créez votre compte pro",
    description: "Avec votre outil ECU (KESS3, Autotuner, Bflash...). Validation rapide.",
    icon: "user-plus"
  },
  {
    step: 2,
    title: "Déposez votre fichier",
    description: "Interface simple. Renseignez votre véhicule et joignez le fichier original.",
    icon: "upload"
  },
  {
    step: 3,
    title: "Recevez en 20 min",
    description: "Fichier optimisé livré rapidement avec support de nos ingénieurs.",
    icon: "download"
  }
];

export const guarantees = [
  { title: "Fichiers en 20 min", description: "Livraison ultra-rapide", icon: "clock" },
  { title: "Factures auto", description: "Comptabilité simplifiée", icon: "file-text" },
  { title: "Support 6j/7", description: "9h-19h30 avec ingénieurs", icon: "headphones" },
  { title: "Paiement sécurisé", description: "CB & Stripe", icon: "shield-check" },
  { title: "Satisfait ou remboursé", description: "Garantie sur tous nos fichiers", icon: "badge-check" }
];

export const advantages = [
  {
    id: 1,
    title: "Rapidité",
    description: "Fichiers renvoyés sous 20 minutes pendant nos heures ouvrées.",
    icon: "clock"
  },
  {
    id: 2,
    title: "Expertise",
    description: "Ingénieurs avec 15 ans d'expérience en reprogrammation moteur.",
    icon: "award"
  },
  {
    id: 3,
    title: "Sécurité",
    description: "Garantie sur tous nos fichiers. Satisfait ou remboursé.",
    icon: "shield"
  },
  {
    id: 4,
    title: "Qualité",
    description: "Fichiers sur mesure optimisés sur banc de puissance.",
    icon: "star"
  }
];

export const ecuTools = [
  "Alientech KESS3",
  "Alientech KESS3 (Slave)",
  "Alientech KESS2",
  "Autotuner (Master)",
  "Autotuner (Slave)",
  "Bflash",
  "Bflash (Slave)",
  "BitBox",
  "CMD Flashtec",
  "DimSport New Genius / Trasdata",
  "Magic Motorsport FlexBox",
  "PCMFlash",
  "Autre outil"
];

export const faqs = [
  {
    id: 1,
    question: "Qui sommes-nous ?",
    answer: "GT Engineering, c'est une équipe d'ingénieurs passionnés avec plus de 15 ans d'expérience dans la reprogrammation moteur. Nous réalisons exclusivement des fichiers sur mesure, adaptés à chaque véhicule et à vos besoins spécifiques. Toujours à la pointe de l'innovation, nous maîtrisons les nouveaux protocoles dès leur sortie."
  },
  {
    id: 2,
    question: "Quels types de fichiers proposez-vous ?",
    answer: "Stage 1 (optimisation moteur d'origine), Stage 2 (avec modifications hardware), Stage 3 (préparation compétition), conversion E85 Flexfuel, solutions FAP/DPF, EGR, Adblue/SCR, Vmax, Pop & Bang, Launch Control, Hard Cut, et bien d'autres options. Nous intervenons sur voitures, motos, poids lourds, pelles mécaniques, tracteurs agricoles, bateaux et jet-skis."
  },
  {
    id: 3,
    question: "Combien de temps pour recevoir mon fichier ?",
    answer: "Notre équipe d'ingénieurs traite généralement les demandes en moins de 20 minutes pendant les heures ouvrées (Lundi-Samedi, 9h-19h30). Pour les demandes urgentes, un service express est disponible. Vous recevez une notification email dès que votre fichier est prêt à télécharger."
  },
  {
    id: 4,
    question: "Quels outils de lecture ECU supportez-vous ?",
    answer: "Notre file service est compatible avec tous les outils majeurs : Alientech KESS3 / KESS2, Autotuner (master & slave), Bflash, BitBox, CMD Flashtec, DimSport New Genius / Trasdata, Magic Motorsport FlexBox, PCMFlash, et tous les formats de fichiers maîtres et esclaves. Nous supportons également les fichiers bench, boot et BDM."
  },
  {
    id: 5,
    question: "Quels véhicules et engins supportez-vous ?",
    answer: "Toutes les marques automobiles : BMW, Mercedes, Audi, Volkswagen, Porsche, Ford, Renault, Peugeot, Citroën, et bien d'autres. Mais aussi les motos (Yamaha, Honda, Kawasaki, Ducati...), les poids lourds (Scania, Volvo, DAF, MAN...), les engins de chantier, les tracteurs agricoles (John Deere, New Holland, Fendt...) et le nautisme (bateaux, jet-skis)."
  },
  {
    id: 6,
    question: "Proposez-vous une garantie ?",
    answer: "Oui, tous nos fichiers sont garantis et testés. En cas de souci, nos ingénieurs interviennent rapidement pour ajuster la cartographie. Satisfait ou remboursé sous conditions."
  }
];
